module.exports = __webpack_public_path__ + "img/INTERIOR-VITARA-1.fd3298ac.jpg";